import { render, staticRenderFns } from "./PVMonitor.vue?vue&type=template&id=861675f4&scoped=true&"
import script from "./PVMonitor.vue?vue&type=script&lang=js&"
export * from "./PVMonitor.vue?vue&type=script&lang=js&"
import style0 from "./PVMonitor.vue?vue&type=style&index=0&id=861675f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861675f4",
  null
  
)

export default component.exports